"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomRangeSelector = exports.RangeDisplay = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = require("../../styles/theme");

var _DateTimePicker = require("./DateTimePicker");

var _buttons = require("../buttons");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var CustomRangeDivider = (
/*#__PURE__*/
0, _styledBase.default)('span', {
  target: "e1cl8tkg0",
  label: "CustomRangeDivider"
})("font-size:", _theme.fonts.sans.size.small, ";margin:0 8px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var CustomRangeButton = (
/*#__PURE__*/
0, _styledBase.default)(_buttons.Button, {
  target: "e1cl8tkg1",
  label: "CustomRangeButton"
})(process.env.NODE_ENV === "production" ? {
  name: "q31t13",
  styles: "div[class*='DateTimeWrapper'] + &{margin-left:10px;}& + i{margin-left:10px;}"
} : {
  name: "q31t13",
  styles: "div[class*='DateTimeWrapper'] + &{margin-left:10px;}& + i{margin-left:10px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
});
var RangeDisplay = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1cl8tkg2",
  label: "RangeDisplay"
})("font-size:", _theme.fonts.sans.size.small, ";margin:3px 0;span{font-weight:", _theme.fonts.sans.weight.bold, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
exports.RangeDisplay = RangeDisplay;

var CustomRangeSelector = function CustomRangeSelector(props) {
  var onRangeSelected = props.onRangeSelected,
      defaultFromDate = props.defaultFromDate,
      defaultToDate = props.defaultToDate;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      fromDate = _useState2[0],
      setFromDate = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      toDate = _useState4[0],
      setToDate = _useState4[1];

  (0, _react.useEffect)(function () {
    setFromDate(defaultFromDate);
    setToDate(defaultToDate);
  }, [defaultFromDate, defaultToDate]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_DateTimePicker.DateTimePicker, {
    onChange: function onChange(selection) {
      setFromDate(selection);
    },
    dateFormat: "MMMM d, yyyy",
    selected: fromDate,
    selectsStart: true,
    startDate: fromDate,
    endDate: toDate,
    maxDate: toDate,
    range: true
  }), _react.default.createElement(CustomRangeDivider, null, "to"), _react.default.createElement(_DateTimePicker.DateTimePicker, {
    onChange: function onChange(selection) {
      setToDate(selection);
    },
    dateFormat: "MMMM d, yyyy",
    selected: toDate,
    selectsEnd: true,
    startDate: fromDate,
    endDate: toDate,
    minDate: fromDate,
    range: true
  }), _react.default.createElement(CustomRangeButton, {
    variant: "primary",
    onClick: function onClick() {
      return onRangeSelected(fromDate, toDate);
    }
  }, "View"));
};

exports.CustomRangeSelector = CustomRangeSelector;
CustomRangeSelector.propTypes = {
  onRangeSelected: _propTypes.default.func.isRequired,
  defaultFromDate: _propTypes.default.instanceOf(Date),
  defaultToDate: _propTypes.default.instanceOf(Date)
};
CustomRangeSelector.defaultProps = {
  defaultFromDate: new Date(),
  defaultToDate: new Date()
};